import React from 'react';
import PropTypes from 'prop-types';
import { IconCheck } from '@americanexpress/dls-icons';
import { Tag } from '@americanexpress/dls-react';

const MultiLevel = (props) => {
  // construct class string for badges
  // level html
  const levelElement = (label, status, loopIndex) => {
    // if the level is reached, render two elements
    // the first is hidden from screen readers and renders a check icon
    // the second is visible only to screen readers and contains real text for them to listen to
    // disable default DLS hover/pointer effects since no mouse action is possible
    if (status === 'ACHIEVED') {
      return (
        <Tag className="pad-1-l" key={`level-${loopIndex}`}>
          <IconCheck isFilled={true} size="xl" color="brand" />
        </Tag>
      );
    }
    // if level is not reached, render a badge with level label
    return <Tag className="pad-1-l" key={`level-${loopIndex}`}>{label}</Tag>;
  };

  // render all levels
  const renderLevels = () => {
    // array to store level elements
    const levelElements = [];
    // loop through breakpoint data and push each levelElement to levelElements array
    props.data?.breakpoints.forEach((breakpoint, loopIndex) => {
      levelElements.push(levelElement(breakpoint.breakLabel, breakpoint.breakStatus, loopIndex));
    });
    return levelElements;
  };

  return (
    <div className="border-t" data-testid="multilevel-component">
      <div className="pad-2-t flex flex-justify-between flex-align-center">
        <div id="levelLabel">{props?.data?.levelLabel}</div>
        <div aria-labelledby="levelLabel">{renderLevels()}</div>
      </div>
    </div>
  );
};

MultiLevel.propTypes = {
  /**
   Multilevel data with row label, text and status for each badge
   */
  data: PropTypes.shape({
    /**
    Label for row of breakpoint badges
     */
    levelLabel: PropTypes.string.isRequired,
    /**
    Array with data for each badge
     */
    breakpoints: PropTypes.arrayOf(
      PropTypes.shape({
        /**
          Breakpoint badge level text
         */
        breakLabel: PropTypes.string.isRequired,
        /**
          Breakpoint badge level status
         */
        breakStatus: PropTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  }).isRequired,
};

export default MultiLevel;
